const DEMO_DATA_BASE = process.env.PUBLIC_URL ? `${process.env.PUBLIC_URL}/demo-data` : '/demo-data';

async function loadJson(path) {
  const res = await fetch(`${DEMO_DATA_BASE}/${path}`, { cache: 'no-store' });
  if (!res.ok) throw new Error(`Failed to load demo data: ${path}`);
  return res.json();
}

export async function loadDemoUsers() {
  return loadJson('users.json');
}

export async function loadDemoStatuses(kind) {
  // kind: attacks | cves | decoys | enums | honeytokens | oldprotocols
  return loadJson(`${kind}.json`);
}

